export enum Mastery {
  RE = 'RE',
  UN = 'UN',
  AP = 'AP',
  AN = 'AN',
  EV = 'EV',
  CR = 'CR',
}

export const { RE, UN, AP, AN, EV, CR } = Mastery

export const masteryCodeClass: Record<Mastery, string> = {
  [RE]: 'text-[#34bb9f]',
  [UN]: 'text-[#1f9bb2]',
  [AP]: 'text-[#3478ab]',
  [AN]: 'text-[#3d53aa]',
  [EV]: 'text-[#813d86]',
  [CR]: 'text-[#b54550]',
}

export const masteryImportantColorClass: Record<Mastery, string> = {
  [Mastery.RE]: '!text-[#34bb9f]',
  [Mastery.UN]: '!text-[#1f9bb2]',
  [Mastery.AP]: '!text-[#3478ab]',
  [Mastery.AN]: '!text-[#3d53aa]',
  [Mastery.EV]: '!text-[#813d86]',
  [Mastery.CR]: '!text-[#b54550]',
}

export const masteryPart = (code: Mastery) => ({
  text: code,
  isBold: true,
  partClasses: `${masteryCodeClass[code]} md:text-lg`,
})
